<ion-grid>
    <ion-row *ngIf="mode == 'edit'">
        <ion-col size="6">
            <h2>Editer mon profil</h2>
        </ion-col>
        <ion-col size="6">
            <ion-button
                (click)="cancel()"
                expand="block"
                fill="clear"
                [mgButtonState]="'dashboard'"
            >
                Annuler
            </ion-button>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col size="12">
            <div *ngIf="mode === 'edit'">
                <ion-segment [(ngModel)]="segmentButtonValue" mode="ios" class="segment-desktop">
                    <ion-segment-button value="profile">
                        <ion-label>Profil</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="passwordSegment">
                        <ion-label>Mot de passe</ion-label>
                    </ion-segment-button>
                </ion-segment>
            </div>

            <div *ngIf="mode === 'new' || segmentButtonValue === 'profile'">
                <ion-grid>
                    <ion-row>
                        <ion-col size="6">
                            <div *ngIf="mode === 'edit'" class="mt-4">
                                <div class="text-2xl mb-4 text-stone-400 font-semibold">
                                    Votre avatar
                                </div>
                                <div class="flex items-center gap-8">
                                    <div class="shrink-0">
                                        <img
                                            class="h-24 w-24 object-cover rounded-full"
                                            [src]="getAvatar()"
                                            alt="Votre photo de profil"
                                        />
                                    </div>
                                    <div class="block">
                                        <ion-button (click)="onGetPhoto()">
                                            Changer la photo
                                        </ion-button>
                                    </div>
                                </div>
                                <div class="image-info">
                                    Images acceptées {{ imagePreviewService.supportedFormats }}.
                                    Poids maxi : 10 Mo.
                                </div>

                                <ion-item>
                                    <ion-toggle
                                        color="primary"
                                        mode="ios"
                                        [(ngModel)]="authService.currentUser.mfa"
                                        (ionChange)="onChangeDoubleAuth($event)"
                                    >
                                        Double authentification
                                    </ion-toggle>
                                </ion-item>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>

            <form [formGroup]="profileForm">
                <div *ngIf="mode === 'new' || segmentButtonValue === 'profile'">
                    <ion-label class="no-item-label">Genre *</ion-label>
                    <ion-select
                        formControlName="gender"
                        interface="popover"
                        placeholder="Veuilez choisir un genre *"
                    >
                        <ion-select-option
                            *ngFor="let gender of userService.genders"
                            [value]="gender.id"
                        >
                            {{ gender.label }}
                        </ion-select-option>
                    </ion-select>
                    <ion-label class="no-item-label">Date de naissance *</ion-label>
                    <input
                        type="text"
                        mask="d0/M0/0000"
                        [leadZeroDateTime]="true"
                        formControlName="dob"
                        placeholder="Date de naissance"
                    />
                    <ion-label class="no-item-label">Prénom *</ion-label>
                    <ion-input
                        required
                        formControlName="firstname"
                        placeholder="Votre prénom"
                    ></ion-input>
                    <div
                        *ngIf="
                            profileForm.get('firstname').invalid &&
                            (profileForm.get('firstname').dirty ||
                                profileForm.get('firstname').touched)
                        "
                    >
                        <ion-text color="danger">Le prénom est obligatoire.</ion-text>
                    </div>
                    <ion-label class="no-item-label">Nom *</ion-label>
                    <ion-input
                        required
                        formControlName="lastname"
                        placeholder="Votre nom"
                    ></ion-input>
                    <div
                        *ngIf="
                            profileForm.get('lastname').invalid &&
                            (profileForm.get('lastname').dirty ||
                                profileForm.get('lastname').touched)
                        "
                    >
                        <ion-text color="danger">Le nom est obligatoire.</ion-text>
                    </div>
                    <ion-label class="no-item-label">E-mail *</ion-label>
                    <ion-input
                        required
                        type="email"
                        formControlName="email"
                        placeholder="Votre adresse e-mail"
                    ></ion-input>
                    <div
                        *ngIf="
                            profileForm.get('email').invalid &&
                            (profileForm.get('email').dirty || profileForm.get('email').touched)
                        "
                    >
                        <ion-text color="danger">L'adresse e-mail n'est pas valide.</ion-text>
                    </div>
                    <ion-label class="no-item-label">Téléphone *</ion-label>
                    <ion-input
                        required
                        type="tel"
                        formControlName="phone"
                        placeholder="01234567890 *"
                    ></ion-input>
                    <div
                        *ngIf="
                            profileForm.get('phone').invalid &&
                            (profileForm.get('phone').dirty || profileForm.get('phone').touched)
                        "
                    >
                        <ion-text color="danger">Le numéro de téléphone est obligatoire.</ion-text>
                    </div>
                </div>
                <ion-label class="no-item-label" *ngIf="segmentButtonValue == 'profile'">
                    Ville *
                </ion-label>
                <input
                    type="text"
                    ngx-google-places-autocomplete
                    ngx-gp-autocomplete
                    [options]="options"
                    (onAddressChange)="handleAddressChange($event)"
                    formControlName="location"
                    *ngIf="segmentButtonValue == 'profile'"
                />
                <div *ngIf="mode === 'new' || segmentButtonValue === 'passwordSegment'">
                    <div class="password">
                        <ion-label class="no-item-label">
                            {{ mode == 'new' ? 'Mot de passe *' : 'Nouveau mot de passe *' }}
                        </ion-label>
                        <input
                            #password
                            [type]="passwordType"
                            required
                            formControlName="password"
                            [placeholder]="
                                mode == 'new' ? 'Mot de passe *' : 'Nouveau mot de passe *'
                            "
                            autocomplete="off"
                        />
                        <ion-icon
                            [name]="passwordType == 'password' ? 'eye' : 'eye-off'"
                            slot="end"
                            class="password-icon"
                            (click)="onShowPassword('pass')"
                        ></ion-icon>
                    </div>

                    <app-password-check
                        [password]="profileForm.value.password"
                        (passwordOk)="isPasswordOk($event)"
                    ></app-password-check>

                    <div class="password">
                        <ion-label class="no-item-label">Confirmation *</ion-label>
                        <input
                            [type]="passwordConfirmType"
                            required
                            formControlName="passwordConfirmation"
                            placeholder="Confirmation du mot de passe *"
                            autocomplete="off"
                        />
                        <ion-icon
                            [name]="passwordConfirmType == 'password' ? 'eye' : 'eye-off'"
                            slot="end"
                            class="password-icon"
                            (click)="onShowPassword('conf')"
                        ></ion-icon>
                    </div>
                    <div
                        *ngIf="
                            profileForm.get('passwordConfirmation').invalid &&
                            (profileForm.get('passwordConfirmation').dirty ||
                                profileForm.get('passwordConfirmation').touched)
                        "
                    >
                        <ion-text color="danger">
                            La confirmation du mot de passe est obligatoire.
                        </ion-text>
                    </div>
                    <div *ngIf="mode === 'new' || segmentButtonValue === 'passwordSegment'">
                        <div class="my-4">
                            <div *ngFor="let policy of policies">
                                <ion-text color="danger" *ngIf="!policy.valid">
                                    {{ policy.text }}
                                </ion-text>
                            </div>
                        </div>
                    </div>
                    <ion-grid *ngIf="mode === 'new'">
                        <ion-row>
                            <ion-col size="7" sizeXs="12" sizeLg="7">
                                <ion-item lines="none" class="ion-item-clear">
                                    <ion-checkbox
                                        slot="start"
                                        color="primary"
                                        formControlName="signature"
                                        class="ion-text-wrap"
                                    >
                                        J'accepte les conditions générales de l'application Margaret
                                    </ion-checkbox>
                                </ion-item>
                            </ion-col>
                            <ion-col size="5" sizeXs="12" sizeLg="5" class="ion-text-center">
                                <ion-button fill="clear" (click)="openCGU()">
                                    (lire les conditions)
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </div>
                <ion-button
                    expand="block"
                    color="orange"
                    *ngIf="!loading"
                    [disabled]="!profileForm.valid && !passwordOk"
                    (click)="mode === 'new' ? register() : update()"
                >
                    {{ mode === 'new' ? "S'enregistrer" : 'Mettre à jour' }}
                </ion-button>
                <ion-button expand="block" color="orange" *ngIf="loading" [disabled]="loading">
                    {{ mode === 'new' ? 'Création en cours...' : 'Mise à jour en cours...' }}
                </ion-button>
                <ion-button
                    expand="block"
                    fill="clear"
                    color="medium"
                    (click)="logout()"
                    *ngIf="mode === 'edit'"
                >
                    Déconnexion
                </ion-button>
                <ion-button
                    (click)="onDestroy()"
                    expand="block"
                    fill="clear"
                    color="danger"
                    *ngIf="mode === 'edit'"
                >
                    Supprimer mon compte
                </ion-button>
            </form>
        </ion-col>
    </ion-row>
</ion-grid>
